import Crud from './crud'
import { export_list } from '@/commons/hpod';
import Vue from 'vue';
var FileSaver = require('file-saver');
var crud = new Crud('orders', 'đơn hàng');

const state = {
    ...crud.state,
    selected: {
        id: 0,
        order_commissions: [],
        order_deposits: [],
        order_services: []
    },
    cost_revenue: {}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    export_order({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list("orders", res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            FileSaver.saveAs(blob, `DanhSachDonHang_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
    export_order_to_buy({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list("orders", res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            FileSaver.saveAs(blob, `HangCanMua_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_to_buy');
    },
};
const mutations = {
    ...crud.mutations
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};